import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { GameSmall } from '../Game/GameSmall.jsx'

export class LiveDobitci extends React.Component {


    constructor(props) {
        super(props);
        this.state = { trentuniDobitakID: 0 };

        this.data = { dobici: [], maksimalniDobitakID: 0 };

        this.fetchData = this.fetchData.bind(this);
        this.setData = this.setData.bind(this);
        this.step = this.step.bind(this);
        this.getClassName = this.getClassName.bind(this);

        this.fetchData();
        this.stepper = setTimeout(this.step, 1000);
    }

    step() {
        // ako može daj novi trenutni id
        var currentId = this.state.trentuniDobitakID;

        var found = false;
        var currentDobitak = 0;
        this.data.dobici.map(x => {
            if (!found && x.id > currentId) {
                currentId = x.id;
                currentDobitak = x.dobitak;
                found = true;
            }
        });

        this.setState({ trentuniDobitakID: currentId });
        this.stepper = setTimeout(this.step, currentDobitak > 1000 ? 5000 : currentDobitak > 100 ? 3000 : 1500);
    }



    fetchData() {
        var promises = Promise.all([casino.repos.casinoLiveDobitciRepo.list(), casino.repos.gameRepo.list()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    componentWillUnmount() {
        this.dataPromises.cancel();
        clearTimeout(this.dataInterval);
        clearTimeout(this.stepper);
    }

    setData(responseData) {
        var [winners, games] = responseData;

        winners.map(x => {
            if (x.id > this.data.maksimalniDobitakID) {
                var game = games.items.filter(y => y.s == x.igraSifra);
                if (game.length == 1) {
                    x.game = game[0];
                    this.data.dobici.push(x);
                    this.data.maksimalniDobitakID = x.id
                }
            }
        });

        // malo pocistimo
        var trentuniDobitakID = this.state.trentuniDobitakID;

        let toShift = 0;

        this.data.dobici.map(x => {
            if (x.id < trentuniDobitakID) {
                toShift++;
            }
        });

        for (let i = 0; i < (toShift - 3); i++)
            this.data.dobici.shift();

        if (this.state.trentuniDobitakID == 0 && this.data.dobici.length)
            this.setState({ trentuniDobitakID: this.data.dobici[0].id });

        var calcInterval = this.data.dobici.length * 1000;

        this.dataInterval = setTimeout(this.fetchData, calcInterval > 30000 ? calcInterval : 30000);
    }
    render() {
        var trentuniDobitakID = this.state.trentuniDobitakID;
        var indexOf = 0;

        this.data.dobici.map((x, index) => {
            if (x.id == trentuniDobitakID) indexOf = index
        });

        return this.data.dobici.map((x, index) =>
            Math.abs(indexOf - index) < 2 ?
                <div key={x.id} className={this.getClassName(x.id, trentuniDobitakID)}>
                    <table style={{ tableLayout: 'fixed', height: '100%' }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '90px' }}>
                                    <GameSmall
                                        routePrefix="/winners"
                                        from="dobitnici"
                                        categories={this.props.categories}
                                        igra={x.game}
                                        showJackpot={true}
                                        extraClass={""}
                                        brands={this.props.brands}
                                    />
                                </td>

                                <td style={{ padding: '0 9px' }}>
                                    <div className='text text-21 text-ellipsis'>{x.igrac && x.igrac.toLowerCase()}</div>
                                    <div className='text text-22 text-ellipsis'>upravo osvaja</div>
                                    <div className='text text-23 text-ellipsis'>{x.game.name}</div>
                                </td>

                                <td className="text-right">
                                    <div className={"dobitak-iznos " + (x.dobitak < 100 ? 'bronze' : x.dobitak < 1000 ? 'silver' : 'gold')}>
                                        <div className="iznos text-ellipsis">
                                            {casino.utils.numberWithCurrencyFromated(x.dobitak, x.valuta)}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> : null
        )
    }

    getClassName(id, shownId) {
        if (id == shownId)
            return "win shown";

        return (id < shownId) ? "win prev" : "win after";
    }

};
